import { GroupChannelListProvider, useGroupChannelListContext } from '@sendbird/uikit-react/GroupChannelList/context';
import { useRouter } from "next/router";
import { UnreadChannelFilter } from "@sendbird/chat/groupChannel";
import { useTranslation } from "next-i18next";

import { Notifications } from "common/ui/Notifications";

import { useSharedOpportunities } from "common/api/getSharedOpportunities";

import styles from "./ChatNotifications.module.scss";

export const ChatNotifications = () => {
  const router = useRouter();
  const { opportunities } = useSharedOpportunities({ retrieveAll: true });

  return (
    <GroupChannelListProvider
      className={styles.GroupChannelListProvider}
      onChannelSelect={channel => router.push({
        pathname: "/chat",
        query: { channelUrl: channel.url },
      })}
      onChannelCreated={undefined} // Don't give option to create channel
      channelListQueryParams={{
        channelUrlsFilter: opportunities?.entities?.length > 0 ? opportunities?.entities?.map(o => o.id) : [""],
        unreadChannelFilter: UnreadChannelFilter.UNREAD_MESSAGE,
      }}
      disableAutoSelect
    >
      <ChatNotificationsContent />
    </GroupChannelListProvider>
  )
}

const ChatNotificationsContent = () => {
  const { t } = useTranslation("common");
  const { groupChannels } = useGroupChannelListContext();
  const { push } = useRouter();

  const unreadMessagesCount = groupChannels?.reduce((acc, channel) => acc + channel.unreadMessageCount, 0);

  return (
    <Notifications
      icon={<ChatIcon />}
      totalNumOfNotifications={unreadMessagesCount}
      action={{
        label: t("chatNotifications.goToChatRoom"),
        onClick: () => { push("/chat") },
      }}
      noNotificationsMessage={t("chatNotifications.noNewChats")}
    >
      {groupChannels.map(channel => {
        return (
          <Notifications.Item
            key={channel.url}
            href={`/chat?channelUrl=${channel.url}`}
            date={new Date(channel.lastMessage.createdAt)}
            subject={channel.name}
            message={channel.lastMessage.message}
            clearNotification={() => channel.markAsRead()}
          />
        )
      })}
    </Notifications>
  )
}

const ChatIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.04 2.30917C6.01344 2.0195 8.00541 1.87439 10 1.875C12.025 1.875 14.0142 2.02334 15.96 2.30834C17.6083 2.55167 18.75 3.995 18.75 5.61667V10.6333C18.75 12.255 17.6083 13.6983 15.96 13.9417C14.3433 14.1783 12.6967 14.3208 11.025 14.3625C10.9419 14.3641 10.8626 14.3975 10.8033 14.4558L7.31667 17.9417C7.22926 18.029 7.11795 18.0884 6.99678 18.1125C6.87561 18.1365 6.75003 18.1242 6.6359 18.0769C6.52176 18.0296 6.42419 17.9496 6.35551 17.8469C6.28682 17.7443 6.25011 17.6235 6.25 17.5V14.2042C5.51107 14.1366 4.77413 14.0487 4.04 13.9408C2.39167 13.6992 1.25 12.2542 1.25 10.6325V5.6175C1.25 3.99584 2.39167 2.55084 4.04 2.30917Z" fill="#5C5F62"/>
    </svg>
  )
}
